import { DataTable } from "@/components/data-table/DataTable";
import { DataTableColumnHeader } from "@/components/data-table/DataTableColumnHeader";
import { format, parseISO } from "date-fns";
import { convertGradeLevelToString } from "@/lib/string-utiils";
import type { ParentStudentListItemDTO } from "@/orval/model";
import {
  getParentStudentsGetParentStudentsForOrganizationQueryKey,
  parentStudentsGetParentStudentsForOrganization,
} from "@/orval/parent-students";
import { createFileRoute } from "@tanstack/react-router";
import type { CustomColumnDef } from "@/types/custom-column-def";
import { PortalPageHeader } from "@/components/portal-page-header";

export const Route = createFileRoute("/_app/organizations/$organizationId/parent/students")({
  component: StudentsParentPage,
});

const studentsColumns: CustomColumnDef<ParentStudentListItemDTO>[] = [
  {
    header: ({ column }) => <DataTableColumnHeader column={column} title="Full Name" />,
    accessorKey: "fullName",
  },
  {
    header: ({ column }) => <DataTableColumnHeader column={column} title="Age" />,
    accessorKey: "age",
  },
  {
    header: "Grade Level",
    accessorFn: (row) => convertGradeLevelToString(row.gradeLevel),
    id: "gradeLevel",
  },
  {
    header: "Date of Birth",
    accessorFn: (row) => format(parseISO(row.dateOfBirth), "MM/dd/yyyy"),
  },
  {
    header: "Organization Status",
    accessorFn: (row) => (row.isInOrganization ? "Active Member" : "Not a Member"),
    id: "organizationStatus",
    sortField: "isInOrganization",
    cell: ({ row }) => (
      <div className="flex items-center">
        <span className={`text-sm ${row.original.isInOrganization ? "text-success" : "text-warning"}`}>
          {row.original.isInOrganization ? "Active Member" : "Not a Member"}
        </span>
      </div>
    ),
  },
];

function StudentsParentPage() {
  const { organizationId } = Route.useParams();
  const getStudents = parentStudentsGetParentStudentsForOrganization;

  return (
    <div className="flex flex-1 min-h-0 flex-col p-4 md:p-6">
      <PortalPageHeader
        className="mb-8 print:mb-2"
        title="Students"
        subtitle={<span className="print:text-black">View your children's membership status</span>}
      />

      <DataTable
        columns={studentsColumns}
        queryFn={(queryOptions) => getStudents(organizationId, queryOptions)}
        queryKeyFn={(params) => getParentStudentsGetParentStudentsForOrganizationQueryKey(organizationId, params)}
        getRowIdFn={(row) => row.childId.toString()}
      />
    </div>
  );
}
